<div class="download-modal-content success-modal" [class.is-handoff]="isActivationHandoff">
    <!-- Success Icon -->
    <!-- Headline -->

    <div class="modal-header">
        <h2 class="success-title">{{ activationTitle }}</h2>
        <button class="close-btn" type="button" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <p class="activation-mode-line" *ngIf="isActivationHandoff">
        <span class="material-symbols-outlined activation-mode-icon" aria-hidden="true">{{ data.versionType === 'silent' ? 'visibility_off' : 'shield_person' }}</span>
        {{ activationModeReassurance }}
    </p>

    <!-- Employee Card -->
    <div class="modal-content">

        <div class="download-options" style="display: none;">
            <div class="option-group">
                <label class="option-label">Application Type</label>
                <mat-radio-group [(ngModel)]="selectedVersionType" class="radio-group" [disabled]="true">
                    <mat-radio-button value="general">General</mat-radio-button>
                    <mat-radio-button value="silent">Silent</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="option-group">
                <label class="option-label">Operating System</label>
                <mat-radio-group [(ngModel)]="selectedOs" class="radio-group" [disabled]="true">
                    <mat-radio-button value="windows">Windows</mat-radio-button>
                    <mat-radio-button value="linux">Linux</mat-radio-button>
                    <mat-radio-button value="mac">macOS</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <div class="employee-card !mb-2">
            <div class="avatar">
                <ngx-avatars [name]="employeeDisplayName" size="48" [initialsSize]="2"></ngx-avatars>
            </div>
            <div class="employee-info">
                <div class="employee-name">
                    {{ employeeDisplayName }}
                </div>
                <div *ngIf="data.versionType === 'general' || data.versionType === 'restricted'"
                    class="employee-details" style="display: flex; gap: 4px; align-items: center;">
                    <div class="employee-email" *ngIf="data.email"
                        style="display: flex; align-items: center;flex-direction: row;">
                        <mat-icon>email</mat-icon>
                        <span>{{ data.email }}</span>
                    </div>
                    <span style="color: #606060; font-size: 18px; font-weight: 500; margin: 0px 4px;"> | </span>
                    <div class="employee-password" *ngIf="data.password"
                        style="display: flex; align-items: center;flex-direction: row;">
                        <mat-icon>lock</mat-icon>
                        <span>{{ data.password }}</span>
                    </div>
                </div>

            </div>
        </div>

        <hr>

        <div class="installer-notice !mt-2" *ngIf="!isActivationHandoff"
            style="background:#e8f5e9;color:#388e3c;border-radius:7px;padding:10px 12px;margin-bottom:16px;display:flex;align-items:center;font-weight:500;">
            <span class="material-symbols-outlined"
                style="color:#43a047;margin-right:7px;font-size:22px;">cloud_download</span>
            <span>The installer is on this computer. Follow the steps below on the employee's computer.</span>
        </div>

        <div class="activation-handoff-panel" *ngIf="isActivationHandoff">
            <div class="activation-download-status" [class.is-done]="hasDownloaded && !downloadInFlight">
                <span class="material-symbols-outlined activation-status-icon" aria-hidden="true">{{ downloadInFlight ? 'hourglass_empty' : (hasDownloaded ? 'check_circle' : 'download') }}</span>
                <div class="activation-status-text">
                    <strong *ngIf="downloadInFlight">Preparing the installer…</strong>
                    <strong *ngIf="!downloadInFlight && hasDownloaded">Installer downloaded</strong>
                    <strong *ngIf="!downloadInFlight && !hasDownloaded">Installer not downloaded yet</strong>
                    <span class="activation-status-file" *ngIf="!downloadInFlight && hasDownloaded">{{ downloadedFileName }}</span>
                </div>
                <button type="button" class="activation-download-btn" [class.is-primary]="!hasDownloaded"
                    [disabled]="downloadInFlight" (click)="startDownload()">
                    {{ hasDownloaded ? 'Download again' : 'Download installer' }}
                </button>
            </div>
            <p class="activation-send-line">Send this file to their computer, then follow these steps there.</p>
            <p class="activation-warn-line">
                <span class="material-symbols-outlined" aria-hidden="true">info</span>
                Your browser or Windows may warn about this file. It's safe — SuperSee generated it.
            </p>
        </div>

        <div class="employee-card-container">
            <div class="activation-steps-head" *ngIf="isActivationHandoff">
                <p class="activation-steps-ref-title">On their {{ activationOsLabel }} computer</p>
                <button type="button" class="activation-copy-btn" *ngIf="canCopySteps" [class.is-copied]="stepsCopied"
                    (click)="copySteps()">
                    <span class="material-symbols-outlined" aria-hidden="true">{{ stepsCopied ? 'check' : 'content_copy' }}</span>
                    {{ stepsCopied ? 'Copied' : 'Copy steps' }}
                </button>
            </div>

            <div class="install-steps-card" [ngSwitch]="isWindows ? 'windows' : data.operatingSystem">
                <div *ngSwitchCase="'windows'">
                    <div class="windows-tabs-container">
                        <div class="activation-os-line" *ngIf="isActivationHandoff">
                            <span>{{ activeWindowsLabel }}</span>
                            <button type="button" class="activation-os-change" [attr.aria-expanded]="showOsPicker"
                                (click)="showOsPicker = !showOsPicker">{{ showOsPicker ? 'Done' : 'Different version?' }}</button>
                        </div>
                        <div class="windows-tab-bar" *ngIf="!isActivationHandoff || showOsPicker">
                            <button type="button" class="windows-tab-btn"
                                [class.active]="activeWindowsTab === 'win_10_11'"
                                (click)="setActiveWindowsTab('win_10_11')">
                                <span class="material-symbols-outlined tab-icon">desktop_windows</span>
                                Windows 10 & 11
                            </button>
                            <button type="button" class="windows-tab-btn"
                                [class.active]="activeWindowsTab === 'win_7_8'"
                                (click)="setActiveWindowsTab('win_7_8')">
                                <span class="material-symbols-outlined tab-icon">computer</span>
                                Windows 7 & 8
                            </button>
                        </div>

                        <!-- Activation handoff: data-driven steps, same wording as "Copy steps" -->
                        <ol class="handoff-steps" *ngIf="isActivationHandoff">
                            <li *ngFor="let step of handoffSteps" [class.is-required]="step.required">
                                <span class="handoff-step-body">
                                    <span class="handoff-step-title">
                                        {{ step.title }}<span class="hl-badge" *ngIf="step.required">Required</span>
                                    </span>
                                    <span class="handoff-step-detail">{{ step.detail }}</span>
                                    <span class="hl-note" *ngIf="step.note"><span class="material-symbols-outlined" aria-hidden="true">push_pin</span>{{ step.note }}</span>
                                </span>
                            </li>
                        </ol>

                        <!-- Tab 1: Windows 10 & 11 (Rust Agent) -->
                        <div class="windows-tab-content" *ngIf="!isActivationHandoff && activeWindowsTab === 'win_10_11'">
                            <div class="install-title">Installation Steps</div>
                            <div class="install-subtitle">
                                Windows 10 & 11 – {{ modeLabel }}
                            </div>
                            <ol>
                                <li class="step-download">
                                    <div class="download-step-text">
                                        <span>📁 Download SuperSee Installer for Windows 10 & 11</span>
                                    </div>
                                    <div class="download-button-container">
                                        <button type="button" (click)="downloadRust()" class="download-button">
                                            <span class="material-symbols-outlined download-icon">download</span>
                                            Download Installer
                                        </button>
                                    </div>
                                    <div class="download-instruction" *ngIf="rustDownloadingFileName">
                                        Package: <b>"{{ rustDownloadingFileName }}"</b>
                                    </div>
                                </li>
                                <li *ngIf="data.versionType !== 'general'">📦 <b>Extract / Unzip:</b> Right-click the
                                    downloaded <b>.zip</b>, choose <b>Extract All</b>, then double-click the
                                    <b>.msi</b> outside the zip.</li>
                                <li *ngIf="data.versionType === 'restricted'" class="hl-keepfile">🖱️ Double-click the
                                    <b>.msi</b>. When Windows asks to allow the app, choose <b>Yes</b>.
                                    <span class="hl-note"><span class="material-symbols-outlined" aria-hidden="true">push_pin</span>Keep <b>SuperSee-Deploy.secrets.json</b> in the same folder as the <b>.msi</b> — the install fails without it.</span>
                                </li>
                                <li *ngIf="data.versionType === 'silent'" class="hl-keepfile">🖱️ Double-click the
                                    <b>.msi</b>. When Windows asks to allow the app, choose <b>Yes</b>.
                                    <span class="hl-note"><span class="material-symbols-outlined" aria-hidden="true">push_pin</span>Keep <b>Settings-Deploy.secrets.json</b> in the same folder as the <b>.msi</b> — the install fails without it.</span>
                                </li>
                                <li *ngIf="data.versionType === 'general'">🖱️ Double-click the installer
                                    (<b>.msi</b>). When Windows asks to allow the app,
                                    choose <b>Yes</b>.</li>
                                <li>⚠️ If prompted by Windows Defender SmartScreen, click <b>More info</b> → <b>Run
                                        anyway</b>, then click <b>Yes</b> on the UAC prompt.</li>
                                <li *ngIf="data.versionType === 'general'">🔐 Employee signs in using the above
                                    credentials.</li>
                                <li *ngIf="data.versionType === 'restricted'">✅ SuperSee starts with this employee's
                                    account automatically.</li>
                                <li *ngIf="data.versionType === 'silent'">✅ Settings starts running silently in the
                                    background — no employee login required. The zip uses Settings names, not
                                    SuperSee.</li>
                                <li class="hl-restart">🔁 Restart the computer after install.<span class="hl-badge">Required</span></li>
                            </ol>
                        </div>

                        <!-- Tab 2: Windows 7 & 8 (Legacy Electron Agent) -->
                        <div class="windows-tab-content" *ngIf="!isActivationHandoff && activeWindowsTab === 'win_7_8'">
                            <div class="install-title">Installation Steps</div>
                            <div class="install-subtitle">
                                Windows 7 & 8 – {{ modeLabel }}
                            </div>
                            <ol>
                                <li class="step-download">
                                    <div class="download-step-text">
                                        <span>📁 Download Agent Installer for Windows 7 & 8</span>
                                    </div>
                                    <div class="download-button-container">
                                        <button type="button" (click)="downloadLegacy()" class="download-button">
                                            <span class="material-symbols-outlined download-icon">download</span>
                                            Download Installer
                                        </button>
                                    </div>
                                    <div class="download-instruction" *ngIf="downloadingFileName">
                                        File: <b>"{{ downloadingFileName }}"</b>
                                    </div>
                                </li>
                                <li>🖱️ Right-click the downloaded file → <b>Run as Administrator</b>.</li>
                                <li>⚠️ If prompted, click <b>More Info</b> → <b>Run Anyway</b>, then click <b>Yes</b> on
                                    both popups.</li>
                                <li>⏳ Let the terminal complete all 8 steps — it will close automatically.</li>
                                <li *ngIf="data.versionType === 'general'">🔐 Employee logs in using the provided
                                    credentials.</li>
                                <li *ngIf="data.versionType === 'silent'">✅ SuperSee runs silently in the background —
                                    no login required. Delete the installer file.</li>
                                <li *ngIf="data.versionType === 'restricted'">🔐 Employee logs in using the provided
                                    credentials (one-time only). Tracking runs automatically.</li>
                                <li class="hl-restart">🔁 Restart the system.<span class="hl-badge">Required</span></li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="'linux'">
                    <ng-container *ngIf="data.versionType === 'general'">
                        <div class="install-title">Installation Steps</div>
                        <div class="install-subtitle">Linux ({{ modeLabel }}) – Installation Steps</div>
                        <ol>
                            <li class="step-download">
                                <div class="download-step-text">
                                    <span>📁 Download Agent Installer for {{data.operatingSystem | titlecase}} ({{ modeLabel }}) mode</span>
                                </div>
                                <div class="download-button-container">
                                    <button mat-raised-button color="primary" (click)="download()"
                                        class="download-button">
                                        <span class="material-symbols-outlined download-icon">
                                            download</span>
                                        Download
                                    </button>
                                </div>
                                <div class="download-instruction">
                                    Share the downloaded file <b>"{{downloadingFileName}}"</b> to the employee's system
                                    or try it on your device
                                </div>
                            </li>
                            <li>
                                🖱️ Right-click → Properties → Permissions
                                <ul style="list-style-type: none; padding-left: 20px;">
                                    <li>✅ Set Read & Write access for "Me", "Group", and "Others"</li>
                                    <li>✅ Check "Allow executing file as program"</li>
                                </ul>
                            </li>
                            <li>🧩 Right-click the .deb file → Open With → Software Install, then click Install.</li>
                            <li>🚀 Once installed, open SuperSee from the Applications menu.</li>
                            <li>🔐 Log in using the credentials provided by the manager.</li>
                            <li>🔁 Restart the system (mandatory step).</li>
                        </ol>
                    </ng-container>
                    <ng-container *ngIf="data.versionType === 'silent'">
                        <div class="install-title">Installation Steps</div>
                        <div class="install-subtitle">Linux ({{ modeLabel }}) – Installation Steps</div>
                        <ol>
                            <li class="step-download">
                                <div class="download-step-text">
                                    <span>📁 Download Agent Installer for {{data.operatingSystem | titlecase}}
                                        ({{ modeLabel }}) mode</span>
                                </div>
                                <div class="download-button-container">
                                    <button mat-raised-button color="primary" (click)="download()"
                                        class="download-button">
                                        <span class="material-symbols-outlined download-icon">
                                            download</span>
                                        Download
                                    </button>
                                </div>
                                <div class="download-instruction">
                                    Share the downloaded file <b>"{{downloadingFileName}}"</b> to the employee's system
                                    or try it on your device
                                </div>
                            </li>
                            <li>
                                🖱️ Right-click → Properties → Permissions
                                <ul style="list-style-type: none; padding-left: 20px;">
                                    <li>✅ Set Read & Write access for "Me", "Group", and "Others"</li>
                                    <li>✅ Check "Allow executing file as program"</li>
                                </ul>
                            </li>
                            <li>🖱️ Right-click the .sh file → Run as Program</li>
                            <li>🔑 If prompted, enter the system password to allow installation.</li>
                            <li>✅ SuperSee agent will install and auto-start silently — no login required.</li>
                            <li>🗑️ Delete the installer file from the employee's system</li>
                            <li>🔁 Restart the system (mandatory)</li>
                        </ol>
                    </ng-container>
                    <ng-container *ngIf="data.versionType === 'restricted'">
                        <div class="install-title">Installation Steps</div>
                        <div class="install-subtitle">Linux ({{ modeLabel }}) – Installation Steps</div>
                        <ol>
                            <li class="step-download">
                                <div class="download-step-text">
                                    <span>📁 Download Agent Installer for {{data.operatingSystem | titlecase}} ({{ modeLabel }}) mode</span>
                                </div>
                                <div class="download-button-container">
                                    <button mat-raised-button color="primary" (click)="download()"
                                        class="download-button">
                                        <span class="material-symbols-outlined download-icon">
                                            download</span>
                                        Download
                                    </button>
                                </div>
                                <div class="download-instruction">
                                    Share the downloaded file <b>"{{downloadingFileName}}"</b> to the employee's system
                                    or try it on your device
                                </div>
                            </li>
                            <li>
                                🖱️ Right-click → Properties → Permissions
                                <ul style="list-style-type: none; padding-left: 20px;">
                                    <li>✅ Set Read & Write access for "Me", "Group", and "Others"</li>
                                    <li>✅ Check "Allow executing file as program"</li>
                                </ul>
                            </li>
                            <li>🧩 Right-click the .deb file → Open With → Software Install, then click Install.</li>
                            <li>🚀 Once installed, open SuperSee from the Applications menu.</li>
                            <li>🔐 Log in using the credentials provided by the manager (one-time only).</li>
                            <li>⚠️ Employee cannot Start/Stop timer or Sign out - tracking auto-starts.</li>
                            <li>📊 Employee can only view their History and widget.</li>
                            <li>🔁 Restart the system (mandatory step).</li>
                        </ol>
                    </ng-container>
                </div>
                <div *ngSwitchCase="'mac'">
                    <ng-container *ngIf="data.versionType === 'general'">
                        <div class="install-title">Installation Steps</div>
                        <div class="install-subtitle">macOS ({{ modeLabel }}) – Installation Steps</div>
                        <ol>
                            <li class="step-download">
                                <div class="download-step-text">
                                    <span>📁 Download Agent Installer for {{data.operatingSystem | titlecase}} ({{ modeLabel }}) mode</span>
                                </div>
                                <div class="download-button-container">
                                    <button mat-raised-button color="primary" (click)="download()"
                                        class="download-button">
                                        <span class="material-symbols-outlined download-icon">
                                            download</span>
                                        Download
                                    </button>
                                </div>
                                <div class="download-instruction">
                                    Share the downloaded file <b>"{{downloadingFileName}}"</b> to the employee's system
                                    or try it on your device
                                </div>
                            </li>
                            <li>🖱️ Open the .dmg file → Drag SuperSee into Applications.</li>
                            <li>🖱️ Right-click SuperSee → Get Info → Set Read & Write for (Me, staff, everyone) under
                                Sharing & Permissions.</li>
                            <li>⚙️ Go to System Settings → Privacy & Security → Allow SuperSee under:
                                <ul style="list-style-type: none; padding-left: 20px;">
                                    <li>• Accessibility</li>
                                    <li>• Screen & Audio Recording</li>
                                </ul>
                            </li>
                            <li>🚀 Launch SuperSee and log in with credentials.</li>
                            <li>🔁 Restart the system (mandatory step).</li>
                        </ol>
                    </ng-container>
                    <ng-container *ngIf="data.versionType === 'silent'">
                        <div class="install-title">Installation Steps</div>
                        <div class="install-subtitle">macOS ({{ modeLabel }}) – Installation Steps</div>
                        <ol>
                            <li class="step-download">
                                <div class="download-step-text">
                                    <span>📁 Download Agent Installer for {{data.operatingSystem | titlecase}}
                                        ({{ modeLabel }}) mode</span>
                                </div>
                                <div class="download-button-container">
                                    <button mat-raised-button color="primary" (click)="download()"
                                        class="download-button">
                                        <span class="material-symbols-outlined download-icon">
                                            download</span>
                                        Download
                                    </button>
                                </div>
                                <div class="download-instruction">
                                    Share the downloaded file <b>"{{downloadingFileName}}"</b> to the employee's system
                                    or try it on your device
                                </div>
                            </li>
                            <li>🖱️ Right-click → Get Info → Set Read & Write for (Me, staff, everyone).</li>
                            <li>
                                💻 Open Terminal, navigate to where you downloaded the file (e.g.,
                                <code>cd ~/Downloads</code>), and run the following commands:
                                <pre
                                    style="background: #f5f5f5; border: 1px solid #ddd; padding: 10px; border-radius: 5px; margin-top: 5px;"><code>sudo chmod +x {{downloadingFileName}}<br>./{{downloadingFileName}}</code></pre>
                            </li>
                            <li>⚙️ After install, you'll see a popup — click Open System Settings, then enable SuperSee
                                under Accessibility and Screen & Audio Recording.</li>
                            <li>✅ SuperSee will auto-start silently — no login required.</li>
                            <li>🗑️ Delete the installer file from the employee's system.</li>
                            <li>🔁 Restart the system (mandatory).</li>
                        </ol>
                    </ng-container>
                    <ng-container *ngIf="data.versionType === 'restricted'">
                        <div class="install-title">Installation Steps</div>
                        <div class="install-subtitle">macOS ({{ modeLabel }}) – Installation Steps</div>
                        <ol>
                            <li class="step-download">
                                <div class="download-step-text">
                                    <span>📁 Download Agent Installer for {{data.operatingSystem | titlecase}} ({{ modeLabel }}) mode</span>
                                </div>
                                <div class="download-button-container">
                                    <button mat-raised-button color="primary" (click)="download()"
                                        class="download-button">
                                        <span class="material-symbols-outlined download-icon">
                                            download</span>
                                        Download
                                    </button>
                                </div>
                                <div class="download-instruction">
                                    Share the downloaded file <b>"{{downloadingFileName}}"</b> to the employee's system
                                    or try it on your device
                                </div>
                            </li>
                            <li>🖱️ Open the .dmg file → Drag SuperSee into Applications.</li>
                            <li>🖱️ Right-click SuperSee → Get Info → Set Read & Write for (Me, staff, everyone) under
                                Sharing & Permissions.</li>
                            <li>⚙️ Go to System Settings → Privacy & Security → Allow SuperSee under:
                                <ul style="list-style-type: none; padding-left: 20px;">
                                    <li>• Accessibility</li>
                                    <li>• Screen & Audio Recording</li>
                                </ul>
                            </li>
                            <li>🚀 Launch SuperSee and log in with credentials (one-time only).</li>
                            <li>⚠️ Employee cannot Start/Stop timer or Sign out - tracking auto-starts.</li>
                            <li>📊 Employee can only view their History and widget.</li>
                            <li>🔁 Restart the system (mandatory step).</li>
                        </ol>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Installer Download Notice -->


        <!-- Installation Steps -->

        <!-- Browser & Security Notice -->
        <div class="browser-security-notice" *ngIf="!isActivationHandoff">
            <div class="notice-line">
                <span class="notice-icon material-symbols-outlined"
                    style="color: #C2410C !important; font-size: 20px;">warning_amber</span>
                <div style="color: #C2410C !important; font-weight: 400; font-size: 12px;">
                    <span style="font-weight: 600;">Browser Notice:</span> You may see "This file isn't commonly
                    downloaded."
                </div>
            </div>
            <div class="notice-line safe-line">
                <span class="notice-icon safe material-symbols-outlined"
                    style="color: #43a047; font-size: 20px;">verified_user</span>
                <div style="color: #C2410C !important; font-weight: 400; font-size: 12px;">It's safe to continue — the
                    file is
                    securely
                    generated by SuperSee.</div>
            </div>
        </div>

        <button type="button" class="activation-return-cta" *ngIf="isActivationHandoff" (click)="close()">
            I've sent it, continue
        </button>
        <p class="activation-cta-caption" *ngIf="isActivationHandoff">Next, we'll watch for them to show as Connected.</p>

        <!-- Download Buttons -->
        <div class="download-section" style="display: none;">
            <p class="auto-download-notice"
                style="font-size: 12px; color: #606060; text-align: center; margin-bottom: 8px;">Your download will
                start automatically. If it doesn't, please use the button below.</p>
            <button mat-flat-button color="primary" (click)="download()">
                Download Installer
            </button>
        </div>

    </div>

</div>